import dayjs from "../../../utility/dayjs";
import Utils from "../../../utility";
const initialState = {
  POList: [],
  order: "DESC",
  sortField: "b2bPurchaseHistory.createdAt",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  PODetail: [],
  b2bPOList: [],
  storeId: null,
  storeName: "",
  productName: "",
  endDate: dayjs().format("YYYY-MM-DD"),
  startDate: dayjs(new Date()).subtract(30, "d").format("YYYY-MM-DD"),
  productId: null,
  detailB2BPO: {},
  invoiceDetail: {},
  invoiceHtmlPo: "",
  status: "",
  paymentList: [],
  paymentStatus: {},
};
export const POReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.PO}`:
      return {
        ...state,
        ...action.payload,
      };
    case `${Utils.ActionName.RESET_PO}`:
      return initialState;

    default:
      return { ...state };
  }
};
